// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

// USA
// https://sandboxapi.acordpay.com/usa
// https://apiusa.acordpay.com/api

// CAN
// https://sandboxapi.acordpay.com/v2
// https://serviceapi.kixpayments.com/v2

export const environment = {
  production: true,
  paymentApiUrl: 'https://sandboxv3.insurepay.com',
  // paymentApiUrl: 'http://localhost:5268',
  zipMask: '00000 0000',
  standalone: false,
  recaptchaSiteKey: '6LcFGnQUAAAAAGGhCuA0Ch9Uz92D7ro48cVaC34S',
  stripeKeyUS: 'pk_test_51PYujzQ823IYYK5quOJQXVenIYYaUaCNUwxi3Zr8xVlIYtNy4qPUIcUBtrOUjFgld078WNSIZOG88fzdiP3URRS500emUeE7a2',
  stripeKeyCA: 'pk_test_51PNeK7RqIsn0AEJmpPbrMD4NTEixJKvgC5m8kB81mNIIuFLRsroD7agIxwWHeGfvMvwuFof6Bbcd7FuDNtkiMA6D000Dw1279M'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
